const theme = process.env.VUE_APP_Theme
module.exports = theme